module.exports = __webpack_public_path__ + "static/img/bg_aima.ef4d27d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_aima.png
// module id = Om7M
// module chunks = 0